
import { Component, Inject, Prop } from 'vue-property-decorator';
import Vue from 'vue';

export type TabSlotFunctions = {
  onSave(): Promise<void>;
};

@Component
export default class TabSlot extends Vue implements TabSlotFunctions {
  @Prop({ required: true })
  id!: string;
  @Prop({ required: true })
  title!: string;
  @Prop({ required: true })
  order!: number;
  @Inject()
  addTab!: (tab: TabSlot) => void;
  @Inject()
  removeTab!: (tab: TabSlot) => void;

  visible = true;

  mounted() {
    this.addTab(this);
  }

  beforeDestroy() {
    this.removeTab(this);
  }

  //passthroughs
  async onSave(): Promise<void> {
    for (let child of this.$children) {
      const onSave = (child as any).onSave;
      if (onSave) {
        await onSave();
      }
    }
  }
}
